import React, { useEffect, useState } from "react";
import classes from "./HeroSection.module.scss";
import { Breadcrumb } from "react-bootstrap";
import CustomImage from "../../CustomImage";
import { isFrappeOrJotFormClass } from "../../../utils/helpers";
import LeadGenForms from "../../EnquiryModal/LeadGenForms";
import useIsMobile from "../../../hooks/useIsMobile";

const HeroSection = ({ alliedServiceData }: any) => {
  const heroSectionData = alliedServiceData?.heroSection ?? {};
  const isMobile = useIsMobile(768);
  const isTab = useIsMobile(1024);

  return (
    <section id="hero-section" className={classes["hero-section-container"]}>
      <picture className={classes["hero-picture"]}>
        <source media="(max-width: 767px)" srcSet={heroSectionData?.backgroundImg?.url ?? ""} />
        <img src={heroSectionData?.backgroundImg?.url ?? ""} loading="eager" fetchPriority="high" decoding="async" width={"100%"} height={"100%"} />
      </picture>

      <div className={classes["content-form-container"]}>
        <div className={classes["content-container"]}>
          <div className={classes["breadcrum-container"]}>
            <Breadcrumb>
              <Breadcrumb.Item style={{ opacity: 0.5 }} href="/">
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item href="" className={classes["breadcrumb-item-2"]}>
                {alliedServiceData?.title}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>

          {heroSectionData?.title && <h1 className={classes.heading}>{heroSectionData?.title}</h1>}
          {heroSectionData?.description && <div className={classes.description} dangerouslySetInnerHTML={{ __html: heroSectionData?.description }}></div>}

          {!isMobile && (
            <div className={classes["feature-container"]}>
              {heroSectionData?.feature?.map((feature: any) => (
                <div className={classes["feature"]}>
                  <div className={classes["icon-container"]}>
                    <CustomImage src={feature?.icon?.url ?? ""} height={20} width={20} alt="left-arrow" />
                  </div>
                  {feature?.title && <div className={classes["feature-title"]} dangerouslySetInnerHTML={{ __html: feature.title }}></div>}
                </div>
              ))}
            </div>
          )}
        </div>

        {!isTab && !isMobile && (
          <div className={`${classes["form-container"]}`}>
            <h2 className={classes["form-heading"]}>Need help with Loan, Forex, Money Transfer or Accommodation?</h2>
            <LeadGenForms
              mode="inline"
              url={process.env.NEXT_PUBLIC_CRM_CF_URL + "/" + (alliedServiceData?.heroSection?.formId ?? "")}
              wrapperClass={classes.inLineFormUniversity}
              loader="shimmer"
            />
          </div>
        )}
      </div>

      {(isMobile || isTab) && (
        <div className={`${classes["form-container"]}`}>
          <h2 className={classes["form-heading"]}>Need help with Loan, Forex, Money Transfer or Accommodation?</h2>
          <LeadGenForms
            mode="inline"
            url={process.env.NEXT_PUBLIC_CRM_CF_URL + "/" + (alliedServiceData?.heroSection?.formId ?? "")}
            wrapperClass={classes.inLineFormUniversity}
            loader="shimmer"
          />
        </div>
      )}
    </section>
  );
};

export default HeroSection;
